import { Slide, SlideProps } from "@material-ui/core";
import React, { forwardRef } from "react";

export const SlideTransition = forwardRef((props: SlideProps, ref) => {
  return <Slide direction="up" {...props} />;
});
